export interface WordPressUser {
  id: number
  username: string
  email: string
  displayName: string
  firstName?: string
  lastName?: string
  avatarUrl?: string
  profilePicture?: string
  roles: string[]
}

export async function getWordPressUser(): Promise<WordPressUser | null> {
  try {
    // First check if we have fresh data from WordPress
    if (typeof window !== "undefined" && (window as any).WP_COCKPIT) {
      const wp = (window as any).WP_COCKPIT
      const isDevMode = wp?.devMode || false
      
      // Debug: Log WordPress data only in dev mode
      if (isDevMode) {
        console.log('[WordPress Auth] WP_COCKPIT data:', wp)
        console.log('[WordPress Auth] Avatar URL from WP:', wp.avatarUrl)
      }
      
      if (wp.isLoggedIn === 'true' || wp.isLoggedIn === true) {
        const user: WordPressUser = {
          id: wp.userId || 0,
          username: wp.username || (wp.displayName ? wp.displayName.replace(/\s+/g, '').toLowerCase() : 'wpuser'),
          email: wp.userEmail || '',
          displayName: wp.displayName || '',
          avatarUrl: wp.avatarUrl || '',
          profilePicture: wp.profilePicture || '',
          roles: wp.roles || []
        }
        
        if (isDevMode) {
          console.log('[WordPress Auth] Parsed user object:', user)
          console.log('[WordPress Auth] Parsed avatar URL:', user.avatarUrl)
        }
        
        try {
          localStorage.setItem('wp_user', JSON.stringify(user))
        } catch (e) {}
        
        return user
      }
    }

    // Fallback to cached user data if no fresh data available
    const cachedUser = localStorage.getItem("wp_user")
    if (cachedUser) {
      const parsed = JSON.parse(cachedUser)
      const isDevMode = (window as any).WP_COCKPIT?.devMode || false
      if (isDevMode) console.log('[WordPress Auth] Using cached user:', parsed)
      return parsed
    }

    return null
  } catch (error) {
    return null
  }
}

export async function logoutWordPress() {
  try {
    localStorage.removeItem("wp_user")
    
    // Call WordPress logout endpoint to clear cookies
    const wpConfig = typeof window !== 'undefined' && (window as any).WP_COCKPIT
    const adminAjaxUrl = wpConfig?.adminAjaxUrl || '/wp-admin/admin-ajax.php'
    const nonce = wpConfig?.nonce || ''
    
    await fetch(adminAjaxUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        action: 'tt_logout',
        nonce: nonce
      }),
      credentials: 'same-origin'
    })
    
    // Redirect to login page with full reload
    window.location.href = (wpConfig?.mountPath || '') + '/login'
  } catch (error) {
    // Even if logout fails, redirect to login
    const wpConfig = typeof window !== 'undefined' && (window as any).WP_COCKPIT
    window.location.href = (wpConfig?.mountPath || '') + '/login'
  }
}

export async function loginWithCredentials(username: string, password: string): Promise<WordPressUser | null> {
  if (username === "admin" && password === "admin") {
    const user: WordPressUser = {
      id: 1,
      username: "admin",
      email: "admin@example.com",
      displayName: "Admin User",
      avatarUrl: "https://www.gravatar.com/avatar/21232f297a57a5a743894a0e4a801fc3?s=40&d=mp",
      roles: ["administrator"],
    }
    localStorage.setItem("wp_user", JSON.stringify(user))
    return user
  }
  return null
}
